// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-datatable-loading-overlay {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.assets-header__customMultiSelect:first-child {
  border-bottom: 1px solid rgb(163, 163, 163) !important;
}

.asset-type-filter,
.asset-type-filter > .assets-header__MultiSelect {
  width: 255px;
}


@media (max-width: 1160px) {
  .assets-table #table-header { 
    flex-wrap: wrap;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/Assets.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;EAEE,YAAY;AACd;;;AAGA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":[".p-datatable-loading-overlay {\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.assets-header__customMultiSelect:first-child {\n  border-bottom: 1px solid rgb(163, 163, 163) !important;\n}\n\n.asset-type-filter,\n.asset-type-filter > .assets-header__MultiSelect {\n  width: 255px;\n}\n\n\n@media (max-width: 1160px) {\n  .assets-table #table-header { \n    flex-wrap: wrap;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
